import Vue from 'vue'
import App from './App.vue'

import router from './router'
import request from './request'
import _global from './base/global'
import method from './base/method'
import url from './base/url'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'


// import '../../theme/index.css'

Vue.prototype.$request = request
Vue.prototype.$global = _global
Vue.prototype.$method = method
Vue.prototype.$url = url

Vue.use(Element)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
